import React from "react";
import ContractChatPage from "./ContractChatPage";

export default function ProposalChatPage() {
  return <ContractChatPage resourcePath="proposals" label="Proposal" />;
}
